import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=5f099c90&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=ts"
export * from "./Partners.vue?vue&type=script&lang=ts"
import style0 from "./Partners.vue?vue&type=style&index=0&id=5f099c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f099c90",
  null
  
)

export default component.exports